import React from 'react';
import { connect } from 'react-redux';
import { setRange, setRangeComplete, setValue, setInputComplete } from '../redux/actions/BikeActions';
import { setUserInfo } from '../redux/actions/UserActions';
import { setPlay360 } from '../redux/actions/FlagActions';
import { isMobile } from 'react-device-detect';

import SearchService from '../classes/SearchService';

import InputRange from 'react-input-range';
// import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import 'react-input-range/lib/css/index.css';

import RangeSlider from './RangeSlider';

const searchService = new SearchService();
const TABLET_BREAKPOINT = 990;

class RangeForm extends React.Component {
    
    constructor(props) {
        super(props);

        this.minRiderHeight = searchService.getHeightRange().min;
        this.maxRiderHeight = searchService.getHeightRange().max;
        this.inchToCMIndex = 2.54;

        this.state = {
            value: this.minRiderHeight,
            windowWidth: undefined
        };

    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }    

    handleResize = () => this.setState({
        windowWidth: window.innerWidth
    });

    onRangeChange = rangeValue => {

        if (isMobile) {
            this.props.dispatch(setValue({ rangeValue }));
        } else {
            this.props.dispatch(setRange(rangeValue, this.props.unit, this.props.color));
        }

        if (this.props.play360) {
            this.props.dispatch(setPlay360({ play360: false }));
        }

    }

    onChangeComplete = value => {
        this.setState({ value })

        this.props.dispatch(setRangeComplete(value, this.props.unit, this.props.date));

        if (this.props.date) {
            this.props.dispatch(setUserInfo(this.props.date, this.props.unit));  
        }        
        
    }

    onInputChange = event => {
        
        this.props.dispatch(setInputComplete(event, this.props.unit, this.props.date ));
        setTimeout(() => {
            this.setState({ value: this.props.value })            
        }, 100);
    }

    setRangeValue = value => {
        this.setState({ value })
        if (this.props.play360) {
            this.props.dispatch(setPlay360({ play360: false }));
        }
    }

    customRangeChange = event => {
        const { value } = event.target;

        this.onChangeComplete(value);

    }

    render() {
        const { value, windowWidth } = this.state;
        const min = this.minRiderHeight;
        const max = this.maxRiderHeight;
        return (
            <div className="range-container" onSubmit={(event) => event.preventDefault()} >
                <p className="height-parameter">{this.props.parameter}</p>
                <div className="range-input-container">
                    <div className="range">
                        { windowWidth <= TABLET_BREAKPOINT
                            ? <RangeSlider 
                                value={Number(value)}
                                onChange={this.customRangeChange}
                                min={min}
                                max={max}
                            />                        
                            : <InputRange
                                minValue={min}
                                maxValue={max}
                                value={Number(value)}
                                onChange={value => this.setRangeValue(value)}
                                onChangeComplete={value => this.onChangeComplete(value)}
                                onInputChange={this.onInputChange}
                            />
                        }
                    </div>                
                </div>
                { !isMobile &&
                    <input 
                        className="manual-range-value"
                        type="number" 
                        onChange={event => this.onInputChange(event)}
                        value={this.props.value}
                        />
                }
                <p className="unit-parameter">{this.props.unit === 'inches' ? 'in' : 'cm'}</p>
            </div>
        )
    }
}

// REDUX STATES
const mapStateToProps = (state) => {
    return {
        render: state.bike.renderIndex,
        value: state.bike.rangeValue,
        unit: state.bike.unit,
        bike: state.bike.bike,
        date: state.user.date,
        play360: state.flags.play360
    }
};

export default connect(mapStateToProps)(RangeForm)


// WEBPACK FOOTER //
// ./src/components/RangeForm.js